import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { ControllerRender, DropDownFilter, TextInput } from 'components/InputsMex/inputs';
import ProgressSpinner from 'components/PogressSpinners/ProgressSpinner';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { TextInput as TextInputNumber } from 'containers/Hogar/componentes/entradas';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router';
import { formatNumber } from 'utils/string';

/**
 *
 * @typedef {object} DatosViviendaProps
 * @property {Campo[]} campos
 * @property {stirng} info
 * @property {string} seccion
 *
 *
 * @param {DatosViviendaProps} props
 * @returns
 */
const DatosVivienda = (props) => {
  const methods = useFormContext();
  const [consultandoValor, setConsultandoValor] = useState(false);
  const params = useParams();
  const { addWarningToast } = useCustomToast();
  const [showFormVivienda, setShowFormVivienda] = useState(false);
  const [showCbxGo4it, setshowCbxGo4it] = useState(true);
  const camposObj = useMemo(() => {
    if (!Array.isArray(props.campos) || props.campos.length === 0) {
      setshowCbxGo4it(false);
      return {};
    }else{
      setshowCbxGo4it(true);
    }
    return Object.fromEntries(
      props.campos.map((campo) => [
        campo.name,
        { ...campo, disabled: consultandoValor, loading: consultandoValor },
      ])
    );
  }, [props.campos, consultandoValor]);


  if (props.campos?.length === 0) {
    return null;
  }



  function toggleFormVivienda(open) {
    setShowFormVivienda(open);
    if (!open) {
      methods.setValue('datosVivienda.datoValorComercial', null);
      methods.setValue('datosVivienda.datoValorConstruccion', null);
      methods.setValue('datosVivienda.datoValorRenta', null);
    }
  }

  const onClickConsultarValor = async () => {
    try {
      const datosVivienda = methods.watch()?.datosVivienda;

      const isValid = await methods.trigger([
        'datosVivienda.datoClaseVivienda',
        'datosVivienda.datoTipoPropiedad',
        'datosVivienda.datoMetrosConstruida',
        'datosVivienda.datoMetrosTerreno',
        'datosVivienda.datoCalle',
        'datosVivienda.datoNumeroExt',
      ]);

      if (isValid) {
        setConsultandoValor(true);
        const Data = {
          ...datosVivienda,
          datoClaseVivienda: datosVivienda?.datoClaseVivienda?.name,
          datoTipoPropiedad: datosVivienda?.datoTipoPropiedad?.name || 2,
          calle: datosVivienda?.datoCalle,
          numeroExterior: datosVivienda?.datoNumeroExt,
          idCarrito: params?.idCotizacion,
        };
        const res = await ApiKeyFetch.instance().post(URLS_PHP_7.hogarCommon.consultarGo4It, Data);
        console.log('RES: ', res);
        if (res?.transaccion) {
          methods.setValue('datosVivienda.datoValorConstruccion', res?.data?.valorDestructible);
          methods.setValue('datosVivienda.datoValorComercial', res?.data?.valuacionComercial);
          methods.setValue('datosVivienda.datoValorRenta', res?.data?.valorRentaSugerida);
        } else {
          methods.setValue('datosVivienda.datoValorComercial', null);
          methods.setValue('datosVivienda.datoValorConstruccion', null);
          methods.setValue('datosVivienda.datoValorRenta', null);
          addWarningToast(res?.errorDescripcion);
        }
        setConsultandoValor(false);
      } else {
        setConsultandoValor(false);
        return addWarningToast('Es necesario rellenar toda la información necesaria para la consulta del valor');
      }
    } catch (error) {
      setConsultandoValor(false);
      addWarningToast(error?.errorDescripcion || '');
    }
    setConsultandoValor(false);
  };

  return (
    <React.Fragment>
      {showCbxGo4it && (<div className="col-12 text-center my-3">
        <h2>{props?.seccion || 'Datos de la vivienda'}</h2>
        <p
          className="font-20px text-primary"
          style={{
            marginBottom: '0px',
          }}
        >
          {props.textos?.showFormQuestion}
        </p>
        <div className="flex">
          <SimpleCheckBox name="showValor" id="showValor" type={'slide'} label={'SI'} onChangeFn={toggleFormVivienda} />
        </div>
      </div>)}
      {showFormVivienda && showCbxGo4it && (
        <div className="col-11 col-xl-10 d-flex flex-wrap justify-content-center border p-5">
          <p className="font-20px text-primary">{props.textos?.titulo}</p>
          <p className="font-20px">{props.textos.disclaimer}</p>
          <div className="row justify-content-around">
            <div className="col-md-5">
              <div className="row row-cols-1">
                {camposObj?.datoTipoPropiedad && <MappCampo {...camposObj?.datoTipoPropiedad} disabled />}
                {camposObj?.datoClaseVivienda && <MappCampo {...camposObj?.datoClaseVivienda} />}
                {camposObj?.datoAnioConstruccion && <MappCampo {...camposObj?.datoAnioConstruccion} disabled />}
                {camposObj?.datoMetrosConstruida && <MappCampo {...camposObj?.datoMetrosConstruida} />}
                {camposObj?.datoMetrosTerreno && <MappCampo {...camposObj?.datoMetrosTerreno} />}
              </div>
            </div>
            <div className="col-md-5">
              <div className="row row-cols-1">
                {camposObj?.datoCalle && <MappCampo {...camposObj?.datoCalle} />}
                {camposObj?.datoNumeroExt && <MappCampo {...camposObj?.datoNumeroExt} />}
                <button
                  type="button"
                  className="btn btn-primary btn-block btn-wrap mx-3"
                  disabled={consultandoValor}
                  onClick={onClickConsultarValor}
                >
                  {!consultandoValor && 'CONSULTAR OPINIÓN DE VALOR DE LA VIVIENDA'}
                  {consultandoValor && 'CONSULTANADO...'}
                </button>

                {consultandoValor && (
                  <div className="col-12 mx-3">
                    <ProgressSpinner label="Consultando..." />
                  </div>
                )}

                <React.Fragment>
                  <ControllerRender
                    name="datosVivienda.datoValorComercial"
                    defaultValue={null}
                    render={({ value }) => !consultandoValor && <ValorSugerido label="Valor comercial" value={value} />}
                  />

                  <ControllerRender
                    name="datosVivienda.datoValorConstruccion"
                    defaultValue={null}
                    render={({ value }) =>
                      !consultandoValor && <ValorSugerido label="Valor de construcción" value={value} />
                    }
                  />

                  <ControllerRender
                    name="datosVivienda.datoValorRenta"
                    defaultValue={null}
                    render={({ value }) => !consultandoValor && <ValorSugerido label="Valor de renta" value={value} />}
                  />
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default DatosVivienda;

/**
 * @typedef {object} Campo
 * @property {string} label
 * @property {string} name
 * @property {boolean} required
 * @property {string|number|object} value
 * @property {'number'|'text'|'select'} type
 * @property {boolean} isFormated
 *
 * @param {Campo} props
 * @returns
 */
const MappCampo = (props) => {
  return (
    <div className="form-group w-100 col-12 mt-2">
      <SimpleContainer
        label={props.label}
        name={`datosVivienda.${props.name}`}
        info={props.info}
        infoIcon={props.infoIcon}
      >
        {(props?.type === 'text' || props?.type === 'number' || props?.type === 'string') && (
          <React.Fragment>
            {!props.isFormated && (
              <TextInput
                inputProps={{
                  name: `datosVivienda.${props.name}`,
                  type: props.type,
                  disabled: props?.disabled || props?.loading,
                }}
                defaultValue={props?.value}
                extrasClasses="hide-arrows"
                numerico={props?.type === 'number'}
                disabled={props.disabled}
                rules={{
                  required: props?.required && 'Este campo es obligatorio',
                  validate: (value) => {
                    if (props.required && value !== '' && props?.type === 'number' && +value === 0) {
                      return 'El valor ingresado no puede ser 0';
                    }
                    return true;
                  },
                }}
              />
            )}
            {props.isFormated && (
              <TextInputNumber
                inputProps={{
                  name: `datosVivienda.${props.name}`,
                  type: props.type,
                }}
                defaultValue={props?.value}
                extrasClasses="hide-arrows"
                numerico={props?.type === 'number'}
                disabled={props.disabled}
                rules={{
                  required: props?.required && 'Este campo es obligatorio',
                  validate: (value) => {
                    if (value !== '' && props?.type === 'number' && +value === 0) {
                      return 'El valor ingresado no puede ser 0';
                    }
                    return true;
                  },
                }}
              />
            )}
          </React.Fragment>
        )}

        {props?.type === 'select' && (
          <DropDownFilter
            name={`datosVivienda.${props.name}`}
            options={props.options}
            helpText="Seleccionar"
            defaultValue={props?.value}
            disabled={props.disabled}
            isClearable
            rules={{
              required: props?.required && 'Este campo es obligatorio',
            }}
          />
        )}
      </SimpleContainer>
    </div>
  );
};
const ValorSugerido = ({ label, value, moneda = '$' }) => {
  if (!value) {
    return null;
  }
  return (
    <div className="w-100 d-flex flex-row justify-content-between mx-3 mt-2">
      <p className="font-source-sans-regular align-self-center font-20px m-0 p-0">
        <strong>{label}</strong>
      </p>
      <p className="font-source-sans-regular align-self-center font-20px m-0 p-0">{formatNumber(value)}</p>
    </div>
  );
};
